<script setup lang="ts">
import { IconChevronUp } from "@tabler/icons-vue";
import {
	SelectScrollUpButton,
	type SelectScrollUpButtonProps,
	useForwardProps,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	SelectScrollUpButtonProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectScrollUpButton
		v-bind="forwardedProps"
		:class="twMerge(
			'flex cursor-default items-center justify-center py-1',
			props.class
		)"
	>
		<slot>
			<IconChevronUp class="h-4 w-4" />
		</slot>
	</SelectScrollUpButton>
</template>
